cb.define(['common/common_VM.Extend.js'], function (common) {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };


    var PM_pmc_pricepreferential_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var unit = cb.rest.AppContext.user.currencyName || "元";

            // viewmodel.get("pricePreferentialItem").setState('defaultSelectedRowIndexes', true);
            // viewmodel.get('pAccumulative').setState('dataSource', [
            //     { value: "0", text: "按全部累计", nameType: "text", disabled: true },
            //     { value: "1", text: "按单品累计", nameType: "text", }
            // ]);

            const displayForbidden = (viewmodel) => {
                if (viewmodel.getParams().mode === 'edit' && nowDates >= viewmodel.get("pStartDate").getValue() && nowDates <= viewmodel.get("pEndDate").getValue()
                    && viewmodel.get("pValid").getValue() == "1") {
                    viewmodel.setReadOnly(true);
                    viewmodel.get('btnBatchOp').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(false);
                    let gridModel = viewmodel.get('pricePreProduct');
                    let actions = gridModel.getCache('actions');
                    let rows = viewmodel.get("pricePreProduct").getRows();
                    let actionsStates = [];
                    rows.forEach(data => {
                      let actionState = {};
                      actions.forEach(action => {
                        if (action.cItemName == "btnDeleteRow") {
                          actionState[action.cItemName] = { visible: false };
                        }
                      });
                      actionsStates.push(actionState);
                    });
                    gridModel.setActionsState(actionsStates);
                } else if (viewmodel.getParams().mode === 'browse' && nowDates >= viewmodel.get("pStartDate").getValue() && nowDates <= viewmodel.get("pEndDate").getValue()
                    && viewmodel.get("pValid").getValue() == "1") {
                    viewmodel.get("btnEdit").setVisible(false);
                }
            }

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {"proId":"id","sProductName":"cName","sProductCode":"code","fSalePrice":"fSalePrice",
                        "fMarketPrice":"fMarkPrice","sProductPicUrl":"url","cDescribe":"modelDescription"};
                    let sku_refRetId = {"proId":"productskus_id","sProductName":"productName","sProductCode":"productCode",
                        "sProductSkuName":"name","sProductSkuCode":"code","fSalePrice":"salePrice","fMarketPrice":"fMarkPrice",
                        "sProductPicUrl":"productUrl","cDescribe":"specs"};
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {"proId":"id","sProductName":"cName","sProductCode":"code","fSalePrice":"fSalePrice",
                        "fMarketPrice":"fMarketPrice","sProductPicUrl":"url","cDescribe":"modelDescription"};
                    let sku_refRetId = {"proId":"productskus_id","sProductName":"productName","sProductCode":"productCode",
                        "sProductSkuName":"name","sProductSkuCode":"code","fSalePrice":"salePrice","fMarketPrice":"fMarketPrice",
                        "sProductPicUrl":"productUrl","cDescribe":"specs"};
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pricePreProduct").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }

            const displayReferType = (viewmodel, value) => {
                var refCode = "";
                var refRetId = "";
                //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                if (value == 1) {
                    refCode = "pc_presentationclassref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 2) {
                    refCode = "pc_producttplref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 3) {
                    refCode = "pc_brandref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 4) {
                    refCode = "pc_tagref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                }
                if (refCode) {
                    viewmodel.get("pricePreProductClass").setRefCode(refCode, refRetId);
                }
            }

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_pricepreferential');
            })

            viewmodel.on('afterEdit',function(data){
                if (this.get('pActivityRange').getValue() == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                    viewmodel.get('actityItemType').setVisible(false);
                } else {
                    viewmodel.get('actityItemType').setVisible(true);
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                    } else {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(true);
                        displayReferType(viewmodel, viewmodel.get("actityItemType").getValue());
                    }
                }
                common.displayChannel(viewmodel, 'pricepreferential');
                common.displayEditButton(viewmodel, "pValid");
            })

          const displayItemValue = (viewmodel) =>{
            let editRowModels = viewmodel.get('pricePreferentialItem').getCache('editRowModels');
            if(editRowModels){
              let len = editRowModels.length;
              for(let i = 0; i < len;i++){
                let editRowModel = editRowModels[i];
                editRowModel.get('consumerPieces').setState('min', 0);
                editRowModel.get('consumerSpending').setState('min', 0);
                editRowModel.get('discountNum').setState('min', 0);
                editRowModel.get('discountNum').setState('max', 10);
                editRowModel.get('fireNum').setState('min', 0);
                if (editRowModel.get('pPreferentialApproach').getValue() == 1) {
                  editRowModel.get('discountNum').setVisible(false);
                  editRowModel.get('fireNum').setVisible(true);
                } else if (editRowModel.get('pPreferentialApproach').getValue() == 2) {
                  editRowModel.get('discountNum').setVisible(false);
                  editRowModel.get('fireNum').setVisible(false);
                } else {
                  editRowModel.get('discountNum').setVisible(true);
                  editRowModel.get('fireNum').setVisible(false);
                }
                if(i > 0){
                  editRowModel.get('isCapping').setVisible(false);
                }
              }
              if(len > 1){
                editRowModels[0].get('isCapping').setVisible(false);
              }
              if(viewmodel.get("pAccumulative").getValue() == 0 || viewmodel.get("applyOffLineChannel").getValue() == 1){
                editRowModels[0].get('btnAddRow3').setVisible(false);
                editRowModels[0].get('btnDeleteRow3').setVisible(false);
              }else{
                editRowModels[0].get('btnAddRow3').setVisible(true);
                editRowModels[0].get('btnDeleteRow3').setVisible(true);
              }
            }
          }

          viewmodel.get("pricePreferentialItem").on('afterInsertRow', function (args) {
            displayItemValue(viewmodel);
          });
          viewmodel.get("pricePreferentialItem").on('afterDeleteRows', function (args) {
            if(args.length > 0){
              displayItemValue(viewmodel);
            }
          });
          viewmodel.get("pricePreferentialItem").on('afterCellValueChange', function (args) {
            let editRowModel = viewmodel.get('pricePreferentialItem').getCache('editRowModels')[args.rowIndex];
            if (args.cellName == 'pPreferentialApproach') {
              if (editRowModel.get('pPreferentialApproach').getValue() == 1) {
                editRowModel.get('discountNum').setVisible(false);
                editRowModel.get('fireNum').setVisible(true);
              } else if (editRowModel.get('pPreferentialApproach').getValue() == 2) {
                editRowModel.get('discountNum').setVisible(false);
                editRowModel.get('fireNum').setVisible(false);
              } else {
                editRowModel.get('discountNum').setVisible(true);
                editRowModel.get('fireNum').setVisible(false);
              }
            }

          });
          viewmodel.on('beforeDeleteRow', function (args) {
            let pricePreferentialItem = viewmodel.get('pricePreferentialItem').getRows();
            if (pricePreferentialItem && pricePreferentialItem.length == 1 && args.params.params.cItemName == 'btnDeleteRow3') {
              cb.utils.alert("只有一个分组无法删除");
              return false;
            }
          })
            viewmodel.on('afterLoadData', function (data) {
                // let fireNum = viewmodel.get("pricePreferentialItem").getEditRowModel().get('fireNum').getValue();
                // viewmodel.get("pricePreferentialItem").setCellValue(0, 'discountNum', fireNum);
                //
                // viewmodel.get("pricePreferentialItem").getEditRowModel().get('fireNum').setState("after", unit);
                displayPrice(viewmodel);
                displayForbidden(viewmodel);
                common.displayChannel(viewmodel, 'pricepreferential');
                common.hideNoStore(viewmodel);
                common.displayEditButton(viewmodel, "pValid");

                if (this.get('memberLevelAll').getValue() == 0) {
                    viewmodel.get('pricePreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('pricePreferentialMemberL').setVisible(false);
                }
                if (this.get('pActivityRange').getValue() == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                    viewmodel.get('actityItemType').setVisible(false);
                } else {
                    viewmodel.get('actityItemType').setVisible(true);
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                    } else {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(true);
                        displayReferType(viewmodel, viewmodel.get("actityItemType").getValue());
                    }
                }
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('iLineDiscount').setVisible(true);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('applicableChannel').setValue(["0"]);
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('iLineDiscount').setVisible(false);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('iLineDiscount').setVisible(false);
                }
                if (this.get('applyOnlineChannel').getValue() == 0) {
                    viewmodel.get('terminalType').setVisible(false);
                } else {
                    viewmodel.get('terminalType').setVisible(true);
                }
                if (this.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('pricePreferentialStore').setVisible(false);
                    viewmodel.get('offLineStore').setValue(1);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (viewmodel.get('offLineStore').getValue() == 1) {
                        viewmodel.get('pricePreferentialStore').setVisible(false);
                    } else {
                        viewmodel.get('pricePreferentialStore').setVisible(true);
                    }
                }
                if (this.get('ifrequency').getValue() == 0) {
                    viewmodel.get('pfrequency').setDisabled(true);
                } else {
                    viewmodel.get('pfrequency').setDisabled(false);
                }
                if (this.get('iPersontime').getValue() == 0) {
                    viewmodel.get('pPersontime').setDisabled(true);
                } else {
                    viewmodel.get('pPersontime').setDisabled(false);
                }
                if (this.getParams().mode === 'add') {
                    viewmodel.get("pricePreferentialItem").appendRow();
                } else {
                  displayItemValue(viewmodel);
                }

                /**InputNumber不为负数**/
                this.get('pfrequency').setState('min', 0);
                this.get('pPersontime').setState('min', 0);
            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('pricePreferentialStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                viewmodel.get('iLineDiscount').setVisible(false);
                var on = 0;
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get('iSendPoint').setVisible(false);
                        viewmodel.get('iLineDiscount').setVisible(false);
                        var on = 1;
                    }
                    if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('pricePreferentialStore').setVisible(false);
                        } else {
                            viewmodel.get('pricePreferentialStore').setVisible(true);
                        }
                        if (on == 0) {
                            viewmodel.get('iSendPoint').setVisible(true);
                            viewmodel.get('iLineDiscount').setVisible(true);
                        }
                    }
                }
                let counts = viewmodel.get('pricePreferentialItem').getRowsCount();
                if(viewmodel.get('applyOffLineChannel').getValue() &&　counts　> 1){
                  var rowIndexes = [];
                  for (let i = counts - 1; i > 0; i--) {
                    rowIndexes.push(i);
                  }
                  viewmodel.get("pricePreferentialItem").deleteRows(rowIndexes);
                }
                displayPrice(viewmodel);
                displayItemValue(viewmodel);
            });

            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value == 1) {
                    viewmodel.get('pricePreferentialStore').setVisible(false);
                } else {
                    viewmodel.get('pricePreferentialStore').setVisible(true);
                }
            });
            viewmodel.get('pAccumulative').on('afterValueChange', function (data) {
              let counts = viewmodel.get('pricePreferentialItem').getRowsCount();
              var rowIndexes = [];
              if(counts > 1){
                for (let i = counts - 1; i > 0; i--) {
                  rowIndexes.push(i);
                }
                viewmodel.get("pricePreferentialItem").deleteRows(rowIndexes);
              }else{
                displayItemValue(viewmodel);
              }

            });

            viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('pricePreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('pricePreferentialMemberL').setVisible(false);
                }
            });


            viewmodel.get('ifrequency').on('afterValueChange', function (data) {
                if (!data.value) {
                    viewmodel.get('pfrequency').setDisabled(true);
                    viewmodel.get('pfrequency').setValue('0');
                } else {
                    viewmodel.get('pfrequency').setDisabled(false);
                }
            });
            viewmodel.get('iPersontime').on('afterValueChange', function (data) {
                if (!data.value) {
                    viewmodel.get('pPersontime').setDisabled(true);
                    viewmodel.get('pPersontime').setValue('0');
                } else {
                    viewmodel.get('pPersontime').setDisabled(false);
                }
            });

            viewmodel.get('pActivityRange').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    if (viewmodel.get('pricePreProductClass').getData() && viewmodel.get('pricePreProductClass').getData().length > 0) {
                        viewmodel.get('pricePreProductClass').setValue([]);
                    }
                    if (viewmodel.get('pricePreProduct').getData() && viewmodel.get('pricePreProduct').getData().length > 0) {
                        var pricenums = viewmodel.get('pricePreProduct').getRowsCount();
                        for (var i = pricenums - 1; i >= 0; i--) {
                            viewmodel.get('pricePreProduct').deleteRows(i);
                        }
                    }
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('actityItemType').setVisible(false);
                    viewmodel.get('pricePreProductClass').setVisible(false);
                } else {
                    viewmodel.get('actityItemType').setVisible(true);
                    if (viewmodel.get('actityItemType').getValue() == 0) {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: true
                        });
                        viewmodel.get('pricePreProductClass').setVisible(false);
                    } else {
                        viewmodel.execute('updateViewMeta', {
                            code: 'goodstab',
                            visible: false
                        });
                        viewmodel.get('pricePreProductClass').setVisible(true);
                        displayReferType(viewmodel, data.value.value);
                    }
                }
            });

            viewmodel.get("actityItemType").on('afterValueChange', function (args) {
                if (viewmodel.get('pricePreProductClass').getShowValue() && viewmodel.get('pricePreProductClass').getShowValue().length > 0) {
                    viewmodel.get('pricePreProductClass').setValue([]);
                }
                if (viewmodel.get('pricePreProduct').getData() && viewmodel.get('pricePreProduct').getData().length > 0) {
                    var pricenums = viewmodel.get('pricePreProduct').getRowsCount();
                    for (var i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('pricePreProduct').deleteRows(i);
                    }

                }
                if (args.value.value == 0) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    viewmodel.get('pricePreProductClass').setVisible(false);
                } else {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('pricePreProductClass').setVisible(true);
                    displayReferType(viewmodel, args.value.value);
                }
            });
            viewmodel.get("pricePreProduct").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'proIdType', 1);
                } else {
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                    this.setCellValue(args.rowIndex, 'proIdType', 0);
                }
            });

            viewmodel.get("pricePreProduct").on("beforeBrowse", function (data) {
                common.productReferBrowseSimple(viewmodel, data, "proIdType", "pricePreProduct");
                return true;
            });

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('pricePreProduct').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("pricePreProduct").deleteRows(rowIndexes);
            })


            viewmodel.on('statictempexport', function (params) {
                const openUrl = params && params.cSvcUrl;
                if (!openUrl) {
                    cb.utils.alert('导出模板的地址为空', 'error');
                    return;
                }
                window.open(openUrl);
            });

            viewmodel.on('batchimport', function (params) {
                const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_pricepreferential`;
                const eleInput = document.createElement('input');
                eleInput.type = 'file';
                eleInput.style.display = 'none';
                eleInput.onchange = function (e) {
                    const formData = new FormData();
                    formData['enctype'] = 'multipart/form-data';
                    formData.append('file', e.target.files[0]);

                    var param = {};
                    param.type = 2;
                    param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    param.applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    formData.append('data', JSON.stringify(param));

                    cb.utils.alert(`导入中，请稍后`, 'info');

                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', url, true);
                    xhr.send(formData);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState !== 4) return;
                        if (xhr.status === 200) {
                            var ajaxResult = JSON.parse(xhr.responseText);
                            if (ajaxResult.code === 200) {
                                if (ajaxResult.data.code === 200) {
                                    var array = [];
                                    var res = ajaxResult.data.data;
                                    var gridModel = viewmodel.get('pricePreProduct');
                                    for (let i = 0; i < res.data.length; i++) {
                                        var appendData = {};
                                        var data = res.data[i];
                                        appendData.proIdType = data.proIdType;
                                        if (appendData.proIdType == 0) {
                                            appendData.sProductCode = data.cCode;
                                            appendData.sProductName = data.cProductName;
                                        } else {
                                            appendData.sProductCode = data.productCode;
                                            appendData.sProductName = data.productName;
                                            appendData.sProductSkuCode = data.cCode;
                                            appendData.sProductSkuName = data.cProductName;
                                        }
                                        appendData.agentId = data.agentId;
                                        appendData.fMarketPrice = data.fMarketPrice;
                                        appendData.fSalePrice = data.fSalePrice;
                                        appendData.iDeleted = data.iDeleted;
                                        appendData.proId = data.proId;
                                        appendData.sProductPicUrl = data.imageUrl;
                                        array.push(appendData);
                                        // gridModel.appendRow(appendData);
                                    }
                                    let count = gridModel.getRowsCount();
                                    var indexes = [];
                                    for (let i = count - 1; i >= 0; i--) {
                                        indexes.push(i);
                                    }
                                    gridModel.deleteRows(indexes);
                                    gridModel.insertRows(0, array);
                                    var errorMessages = '';
                                    if (res.errorCount) {
                                        for (let i = 0; i < res.allMsgs.length; i++) {
                                            if (res.allMsgs[i].isError) {
                                                errorMessages += res.allMsgs[i].msg;
                                            }
                                        }
                                    }
                                    cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${res.errorMsgs + errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                                } else {
                                    cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                                }
                            } else {
                                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
                            }
                        }
                    };
                    document.body.removeChild(eleInput);
                };
                document.body.appendChild(eleInput);
                eleInput.click();
            });

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);

                obj.iAreaId = null;

                if (obj.pActivityRange == '1') {
                    if (obj.actityItemType != 0) {
                        if (!viewmodel.get('pricePreProductClass').getShowValue() || viewmodel.get('pricePreProductClass').getShowValue().length == 0) {
                          switch (obj.actityItemType) {
                                case 1:
                                case '1':
                                    cb.utils.alert('请选择相应的分类信息', 'warning');
                                    return false;
                                case 2:
                                case '2':
                                    cb.utils.alert('请选择相应的模板信息', 'warning');
                                    return false;
                                case 3:
                                case '3':
                                    cb.utils.alert('请选择相应的品牌信息', 'warning');
                                    return false;
                                case 4:
                                case '4':
                                    cb.utils.alert('请选择相应的标签信息', 'warning');
                                    return false;
                            }
                        } else {
                            if (obj.pricePreProductClass) {
                                for (let i = 0; i < obj.pricePreProductClass.length; i++) {
                                    let proClass = obj.pricePreProductClass[i];
                                    proClass['iReferType'] = viewmodel.get("actityItemType").getValue() - 1;
                                }
                            }
                        }
                    } else {
                        if (viewmodel.get('pricePreProduct').getRows() == '') {
                            cb.utils.alert('请选择相应的商品信息', 'warning');
                            return false;
                        } else {
                            for (var i = 0; i < viewmodel.get('pricePreProduct').getRows().length; i++) {
                                if (!viewmodel.get('pricePreProduct').getRows()[i].proId ) {
                                    cb.utils.alert('第' + (i + 1) + '行选择相应的商品信息', 'warning');
                                    return false;
                                }
                            }
                        }
                    }
                }

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('memberLevelAll').getValue() == '0' && this.get('pricePreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('memberLevelAll').getValue() != '0') {
                    obj.pricePreferentialMemberL = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('pricePreferentialStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.memberLevelAll == 1) {
                        obj.memberLevelAll = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.pricePreferentialStore = [];
                }
                // else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '0') {
                //                 cb.utils.alert('线下门店不能为空', 'warning');
                //                 return false;
                //             }

                // if (mode == 'add') {
                //     if (viewmodel.get('pStartDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }
                if (viewmodel.get('pStartDate').getValue() >= viewmodel.get('pEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (viewmodel.get('ifrequency').getValue() == 1 && (!viewmodel.get('pfrequency').getValue() || viewmodel.get('pfrequency').getValue() == 0)) {
                    cb.utils.alert('请正确填写每人参加次数', 'warning');
                    return false;
                }
                if (viewmodel.get('iPersontime').getValue() == 1 && (!viewmodel.get('pPersontime').getValue() || viewmodel.get('pPersontime').getValue('') == 0)) {
                    cb.utils.alert('请正确填写参加优惠人数', 'warning');
                    return false;
                }
              for (var i = 0; i < viewmodel.get('pricePreferentialItem').getRows().length; i++) {
                let priceItem = viewmodel.get('pricePreferentialItem').getRows()[i];
                if(priceItem.consumerPieces === undefined||priceItem.consumerPieces == 0){
                  cb.utils.alert('第' + (i + 1) + '行的优惠件数条件不可为0或空', 'warning');
                  return false;
                }
                if(priceItem.pPreferentialApproach == 0 && (priceItem.discountNum == null||priceItem.discountNum == 0)){
                  cb.utils.alert('第' + (i + 1) + '行的折扣数不可为0或空', 'warning');
                  return false;
                }
                if(priceItem.pPreferentialApproach == 1 && (priceItem.fireNum == null || priceItem.fireNum == 0)){
                  cb.utils.alert('第' + (i + 1) + '行的减价数不可为0或空', 'warning');
                  return false;
                }
                if(i > 0){
                  let prePriceItem = viewmodel.get('pricePreferentialItem').getRows()[i-1];
                  if(priceItem.consumerPieces <= prePriceItem.consumerPieces){
                    cb.utils.alert('第' + (i + 1) + '行的优惠件数条件不可小于前一行', 'warning');
                    return false;
                  }
                }

              }
              if(obj.pricePreferentialItem){
                for(var i = 0; i < obj.pricePreferentialItem.length; i++){
                  let priceItem = obj.pricePreferentialItem[i];
                  if(priceItem.pPreferentialApproach == 0){
                    priceItem.fireNum = priceItem.discountNum;
                  }
                }
              }



                data.data.data = JSON.stringify(obj);

            })
        }
    };
    try {
        module.exports = PM_pmc_pricepreferential_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_pricepreferential_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_pricepreferential_VM.Extend.js